import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Container from '@components/ui/Container/Container'
import { findRichTextLink } from '@lib/findRichTextLink'

import SignatureMark from '@components/icons/SignatureMark/SignatureMark'
import Button from '@components/ui/ButtonV2/Button'
import Media from '@components/ui/Media/Media'

import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC } from 'react'
import { UmbracoLink } from 'types/umbracoLink'
import { ModuleProps } from '..'
import styles from './M21.module.scss'

export type M21Props = {
  header1?: string
  headerFontType?: string
  richText?: string
  mediaPicker?: MediaWithCropsFragment
  link?: UmbracoLink
  cTAType?: string
  textColor?: string
  backgroundColor?: string
  reversed?: boolean
  displaySignatureMark?: boolean
  backgroundColorPicker?: string
} & ModuleProps

const M21: FC<M21Props> = ({
  header1,
  headerFontType,
  richText,
  mediaPicker,
  reversed,
  textColor,
  backgroundColor,
  link,
  cTAType,
  lcp,
  displaySignatureMark,
  backgroundColorPicker,
}) => {
  return (
    <Container
      className={styles.noPadding}
      fluid
      backgroundColor={backgroundColorPicker ?? backgroundColor}
      color={textColor}
    >
      <div className={`${styles.container} ${reversed && styles.reversed}`}>
        <div className={styles.innerContainer}>
          <Link
            link={link ?? findRichTextLink(richText)}
            className={styles.imageContainer}
          >
            <Media
              mediaWithCrops={mediaPicker}
              mediaClassName={clsx(styles.image, {
                [styles.gifContainer]:
                  mediaPicker?.media?.__typename == 'Image' &&
                  mediaPicker?.media?.url?.endsWith('.gif'),
              })}
              priority={lcp}
              sizes="(min-width: 1520px) 35vw,(min-width: 767px) 45vw, 100vw"
            />
          </Link>

          <div className={styles.contentContainer}>
            <div className={styles.innerTextContent}>
              {header1 && (
                <h2 className={clsx(headerFontType, styles.header)}>
                  {header1.split(' ').map((word, index) => {
                    if (index === 0) {
                      return <span key={index}>{word}</span>
                    } else {
                      return header1.split(' ').length === index + 1
                        ? word
                        : word + ' '
                    }
                  })}
                </h2>
              )}
              <div className={styles.containerClass}>
                {displaySignatureMark && (
                  <SignatureMark className={styles.signatureMark} />
                )}
                <div className={styles.textContent}>
                  <TrustedHtml html={richText} className={styles.richText} />
                  {link && (
                    <Button
                      as={Link}
                      link={link}
                      size="medium"
                      className={styles.button}
                      variant={cTAType.toLowerCase() as any}
                    >
                      {link.name}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default M21
